var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wycMain"},[_c('div',[_c('el-input',{staticClass:"input",model:{value:(_vm.getTitle),callback:function ($$v) {_vm.getTitle=$$v},expression:"getTitle"}})],1),_c('iframe',{staticClass:"iframe",attrs:{"id":"_5118_Wyc_Box","src":_vm.wycUrl}}),_c('WycListBtn',{class:[
      !_vm.rightShow
        ? _vm.contentWidth < 1600
          ? _vm.contentWidth < 1400
            ? 'listbutton3'
            : 'listbutton2'
          : 'listbutton'
        : _vm.contentWidth < 1400
        ? 'listbutton4'
        : 'listbutton1'
    ]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }